export default __webpack_public_path__ + "static/clients-qbit-logo-487de74a121a28a8606ea99cdb4c7984.svg";